const snackDuration = 1 * 1000;
const zohoFolderStructureMap = {
  Leads: [
    {
      id: 0,
      title: "${Full_Name}",
      children: [],
      expanded: true,
      information: {},
    },
  ],
  Accounts: [
    {
      id: 0,
      title: "${Account_Name}",
      children: [
        {
          title: "Associated Deals",
          information: {},
        },
        {
          title: "Associated Contacts",
          information: {},
        },
      ],
      expanded: true,
      information: {},
    },
  ],
  Contacts: [
    {
      id: 0,
      title: "${Full_Name}",
      children: [
        {
          title: "Associated Deals",
          information: {},
        },
      ],
      expanded: true,
      information: {},
    },
  ],
  Deals: [
    {
      id: 0,
      title: "${Deal_Name}",
      children: [],
      expanded: true,
      information: {},
    },
  ],
};
export const authCheckDuration = 10 * 1000;
export const maxAuthCheck = 10;

export const snackDetails = {
  duration: snackDuration,
  open: false,
  severity: "success",
  message: "Successfull",
};

export const getOpenSnakSuccessData = (
  message = "Successfull!!!",
  duration = snackDuration
) => {
  return {
    duration: duration,
    open: true,
    severity: "success",
    message: message,
  };
};

export const getCloseSnakData = (prev) => {
  return {
    duration: snackDuration,
    open: false,
    severity: prev?.severity || "success",
    message: "",
  };
};

export const getOpenSnakErrorData = (
  message = "Error!!!",
  duration = snackDuration
) => {
  return {
    duration: duration,
    open: true,
    severity: "error",
    message: message,
  };
};

export const getZohoFolderStructure = (module) => {
  return zohoFolderStructureMap?.[module] || [];
};

export const contactAdminMessage = "Please contact with admin";
export const unauthenticatedMessage =
  "You are not authenticated. Please contact with admin";
export const informationMissingMessage =
  "Required information missing. Please contact with admin";

export const views = [
  {
    name: "Icon View",
    value: "list",
  },
  {
    name: "Thumbnail View",
    value: "grid",
  },
  {
    name: "Details",
    value: "details",
  },
];

export const pageSizeList = [8, 10, 15, 25, 50, 100];
// setSnack;
